document.addEventListener("DOMContentLoaded", () => {
  const addToCartButton = document.querySelector(
    'button[name="add"].btn--add-to-cart'
  );

  const stickyCart = document.querySelector(".sticky-cart");

  if (addToCartButton && stickyCart) {
    stickyCart.style.display = "none";

    // Function to check if the button is in the viewport
    const isElementInViewport = (element) => {
      const rect = element.getBoundingClientRect();
      return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <=
          (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <=
          (window.innerWidth || document.documentElement.clientWidth)
      );
    };

    window.addEventListener("scroll", () => {
      if (isElementInViewport(addToCartButton)) {
        stickyCart.style.display = "none";
      } else {
        stickyCart.style.display = "flex";
      }
    });
  }

  const primarySelector = document.querySelectorAll(
    '#variant-selector-primary input[type="radio"]'
  );
  const stickySelector = document.querySelectorAll(
    '#variant-selector-sticky input[type="radio"]'
  );
  const syncRadioButtons = (sourceRadios, targetRadios) => {
    let isSyncing = false; // Flag to prevent recursive triggering
  
    const handleChange = (sourceRadio, sourceToTarget) => {
      if (isSyncing) return; // Prevent recursive calls
  
      isSyncing = true;
      const targetRadiosToSync = sourceToTarget ? targetRadios : sourceRadios;
  
      if (sourceRadio.checked) {
        const value = sourceRadio.value;
        targetRadiosToSync.forEach((targetRadio) => {
          if (targetRadio.value === value && !targetRadio.checked) {
            targetRadio.checked = true;
            targetRadio.dispatchEvent(new Event("change", { bubbles: true }));
          }
        });
      }
  
      isSyncing = false;
    };
  
    // Attach event listeners for source radios
    sourceRadios.forEach((sourceRadio) => {
      sourceRadio.addEventListener("change", () => handleChange(sourceRadio, true));
    });
  
    // Attach event listeners for target radios
    targetRadios.forEach((targetRadio) => {
      targetRadio.addEventListener("change", () => handleChange(targetRadio, false));
    });
  };
  
  // Synchronize both directions
  syncRadioButtons(primarySelector, stickySelector);
  syncRadioButtons(stickySelector, primarySelector);
  

  const button = document.querySelector(
    ".sticky-cart .btn--add-to-cart .btn-state-ready"
  );
  let originalText = button.textContent;
  if (window.innerWidth <= 768) {
    button.textContent = "Añadír";
  } else {
    button.textContent = originalText;
  }
});
